import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import { useTranslation } from "react-i18next";
import {
  getSelectFieldOptionKey,
  getSelectFieldOptions,
  getTranslatedText,
  getTranslatedTooltip,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import FormGroup from "features/shared/forms/components/FormGroup";
import reactSelectStyles from "features/shared/components/reactSelect/reactselectcustom.module.scss";
import Select from "react-select";

interface Props extends FormFieldProps {
  isMultiple?: boolean;
}

const ReactSelectBaseField = ({ descriptor, formHandler, isMultiple }: Props) => {
  // translations
  const tEnums = useTranslation(
    descriptor.options?.enumTranslationPath ?? ""
  ).t;
  const tLabels = useTranslation("shared\\dynamicForms").t;
  const tFields = useTranslation("shared\\dynamicFormsFields").t;

  // form hook props
  const { bindReactSelectField, errors } = { ...formHandler };

  // helpers
  const getPlaceholder = () => { 
    const placeholder = getTranslatedText(descriptor, "placeholder", tLabels);
    return placeholder ?? tFields("reactSelectBaseField.defaultPlaceholder");
  }

  // render
  return (
    <div className={descriptor.className}>
      <FormGroup
        labelText={getTranslatedText(descriptor, "label", tLabels)}
        validationError={errors ? errors[descriptor.name] : undefined}
        tooltip={getTranslatedTooltip(descriptor, tLabels)}
      >
        <Select
          {...bindReactSelectField<any>(
            descriptor.name,
            getSelectFieldOptionKey(descriptor.options?.optionValue, "value"),
            getSelectFieldOptions<any>(descriptor, [], tEnums),
            isMultiple
          )}
          getOptionLabel={(x) => x[descriptor.options?.optionName ?? "name"]}
          captureMenuScroll={false}
          className={reactSelectStyles.customSelect}
          classNamePrefix="customSelect"
          placeholder={getPlaceholder()}
          noOptionsMessage={() => tFields("reactSelectBaseField.noOptions")}
        />
      </FormGroup>
    </div>
  );
};

export default ReactSelectBaseField;
